<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>报表</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>日报明细表</el-breadcrumb-item>
      <el-breadcrumb-item>运单流水</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">时间段</span>
        <el-select style="width: 110px" v-model="filter.queryType" placeholder="请选择">
          <el-option v-for="item in timeOptions" :label="item.label" :value="item.value" :key="item.value"> </el-option>
        </el-select>
        <!-- <time-select-report @timecallback="timeChange"></time-select-report> -->
        <el-date-picker
          v-model="filter.beginDate"
          type="datetime"
          placeholder="选择开始时间"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="filter.endDate"
          type="datetime"
          placeholder="选择结束时间"
          default-time="23:59:59"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-1">
        <el-input v-model.trim="filter.keyword" style="width: 280px" placeholder="搜索运单号"></el-input>
      </div>
      <div class="toolbar-item" id="auto-2">
        <el-popover ref="popoverpack" trigger="hover" placement="top-start" width="230">
          已选<span class="font-orange">{{ tableData.total || 0 }}</span
          >条运单（最大1000条运单）
        </el-popover>
        <el-button type="primary" size="small" @click="screenList">筛选</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 运单流水 </span>
      </div>
      <div class="fr">
        <el-button type="primary" v-popover:popoverpack size="small" @click="receiptPack" id="auto-3"
          >回单打包</el-button
        >
        <el-button type="primary" size="small" @click="downloadPack" id="auto-4">下载管理</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-5">
      <el-table :data="tableData.data" border>
        <el-table-column prop="orderNumber" label="运单号"> </el-table-column>
        <el-table-column prop="orderCreateTime" label="下单时间"> </el-table-column>
        <el-table-column prop="orderSignTime" label="收单时间"> </el-table-column>
        <el-table-column prop="tradecount" label="交易数量"> </el-table-column>
        <el-table-column type="expand" width="100" label="明细">
          <template v-slot="props">
            <el-table :data="props.row.list" border max-height="500">
              <el-table-column prop="tradeName" label="交易名称" min-width="150"> </el-table-column>
              <el-table-column prop="tradeDate" label="交易日期" min-width="110"> </el-table-column>
              <el-table-column prop="tradeTime" label="交易时间" min-width="110"> </el-table-column>
              <el-table-column prop="incomeAmt" label="收" min-width="110"> </el-table-column>
              <el-table-column prop="payoutAmt" label="支" min-width="110"> </el-table-column>
              <el-table-column prop="thirdCode" label="电子回单" min-width="110">
                <template v-slot="scope">
                  <el-button v-if="scope.row.isDownLoad" @click="showPDF(scope.row.thirdCode)" type="text" size="small"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <!-- 打包列表 -->
    <el-dialog title="下载管理" :visible.sync="dialogTableVisible" custom-class="dia-w900">
      <div class="mb-10">
        <el-pagination
          :page-size="pageSize"
          :current-page.sync="downloadTablePage"
          :total="downloadTableData.total"
          @current-change="downloadTableChange"
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <el-table :data="downloadTableData.data" border>
        <el-table-column prop="downCount" label="下载运单数" width="90"></el-table-column>
        <el-table-column label="时间条件" width="100">
          <template v-slot="scope">
            <span v-if="scope.row.timeQueryType == 1">下单时间</span>
            <span v-if="scope.row.timeQueryType == 2">收单时间</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="开始时间" width="140">
          <template v-slot="scope">
            {{ scope.row.queryStartTime }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="140">
          <template v-slot="scope">
            {{ scope.row.queryEndTime }}
          </template>
        </el-table-column>

        <el-table-column prop="userName" label="申请人" width="140"></el-table-column>
        <el-table-column label="操作">
          <!-- operStatus :0 打包成功；1.初始化;2.打包中；3.打包失败 -->
          <template v-slot="scope">
            <div v-if="scope.row.operStatus == '0'">
              <div v-if="scope.row.invalitData > 0">
                <a :href="scope.row.downUrl" class="font-green">下载</a>
                (<span class="font-red">{{ scope.row.invalitData }}</span
                >天后到期)
              </div>
              <div v-else class="font-gray">已失效</div>
            </div>
            <div v-else :class="operStatusObj[scope.row.operStatus].cls">
              {{ operStatusObj[scope.row.operStatus].text }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:5
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/report.new.api';
import { WUYI } from '@/api/common';
import dateLimit from '@/api/dateLimit';
export default {
  data() {
    return {
      pageSize: 20,
      currentPage: 1,
      filter: {
        queryType: 1,
        beginDate: new Date(dateLimit.getThreeMonth()).getTime(),
        endDate: dateLimit.currentDayEnd.getTime() - 8.64e7,
        keyword: '',
        chlType: '',
        taxChlType: null,
        taxCompanyId: ''
      },
      cache: {},
      timeOptions: [
        { label: '下单时间', value: 1 },
        { label: '收单时间', value: 2 }
      ],
      tableData: {
        total: 0,
        data: []
      },

      dialogTableVisible: false,
      downloadTableData: {
        data: [],
        total: 0
      },
      downloadTablePage: 1,
      tradeTypeArr: ['1', '2', '3'],
      operStatusObj: {
        0: {
          text: '打包成功',
          cls: 'font-green'
        },
        1: {
          text: '初始化',
          cls: 'font-red'
        },
        2: {
          text: '打包中',
          cls: 'font-orange'
        },
        3: {
          text: '打包失败',
          cls: 'font-red'
        }
      },
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime() - 8.64e7) {
            return true;
          }
          return false;
        }
      }
    };
  },
  created() {
    this.filter.chlType = this.$route.params.chlType || '';
    this.filter.taxChlType = this.$route.params.taxChlType || null;
    this.filter.taxCompanyId = this.$route.params.taxCompanyId || '';
  },
  methods: {
    screenList() {
      if (!WUYI.checkDate(this.filter.beginDate, this.filter.endDate)) return;
      this.cache = { ...this.filter };
      this.currentPage = 1;
      this.ajaxRequest();
    },
    //分页点击
    handleCurrentChange(val) {
      this.currentPage = val;
      this.ajaxRequest();
    },
    ajaxRequest() {
      let options = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.cache };
      axios.post(api.orderWaterListOrder, options).then(res => {
        this.tableData = res.data;
      });
    },
    showPDF(thirdCode) {
      axios.post(api.orderWaterLookOrderBill, { thirdCode: thirdCode }).then(res => {
        window.open(res.data);
      });
    },
    // 回单打包
    receiptPack() {
      if (this.tableData.total == 0) {
        this.$message.warning('未查询到数据，请重新筛选');
        return;
      }
      axios.post(api.orderWaterPackOrder, { ...this.cache }).then(res => {
        this.$message.success('提交成功');
      });
    },
    // 下载管理
    downloadPack() {
      this.downloadTablePage = 1;
      this.getPackData().then(res => {
        this.dialogTableVisible = true;
      });
    },
    getPackData() {
      return new Promise((resolve, reject) => {
        axios
          .post(api.orderWaterListDownOrder, {
            pageNum: this.downloadTablePage,
            pageSize: this.pageSize,
            queryType: 2,
            chlType: this.filter.chlType,
            taxChlType: this.filter.taxChlType,
            taxCompanyId: this.filter.taxCompanyId
          })
          .then(res => {
            this.downloadTableData.data = res.data.data;
            this.downloadTableData.total = res.data.total;
            resolve();
          });
      });
    },
    downloadTableChange(val) {
      this.downloadTablePage = val;
      this.getPackData();
    }
  }
};
</script>
